import { useState } from "react";
import { Checkbox } from "@nextui-org/react";
import GoalTime from "./GoalTime";
import FirstGoalTime from "./FirstGoalTime";
import GoalNumber from "./GoalNumber";
import Header from "@/components/client/Header";

const Content = ({ tabs, goalStats }) => {
  const [activeTab, setActiveTab] = useState(tabs[0].slug);
  const [isSameChecked, setIsSameChecked] = useState(false);

  const handleChangeTab = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className={"lg:px-[34px]"}>
      <div className={"flex flex-row  mt-4 lg:[&>*]:flex-1 "}>
        <div
          className={"flex flex-row items-center justify-between mb-4 gap-1 "}
        >
          <div
            className={
              "flex flex-col lg:flex-row justify-start gap-1 lg:gap-4 [&>*]:flex [&>*]:flex-row [&>*]:justify-start lg:[&>*]:justify-center [&>*]:items-end lg:[&>*]:items-center [&>*]:gap-2 "
            }
          >
            <div>
              <div className={"w-3.5 h-3.5 bg-button-blue-bet"}></div>
              <div className={""}>Chủ</div>
            </div>
            <div>
              <div className={"w-3.5 h-3.5 bg-golden-yellow"}></div>
              <div className={""}>Khách</div>
            </div>
          </div>

          <div className="flex justify-evenly [&>*]:text-center [&>*:first-child]:pl-[0] [&>*:last-child]:pr-[0] font-bold text-xxs [&>*]:@md:px-[17px] divide-league-dark-detail text-blur-gray bg-white dark:bg-dark-slate rounded-[4px] divide-x-[1px] p-2">
            {Array.isArray(tabs) && tabs.length > 0
              ? tabs.map((tab) => (
                  <div
                    key={tab.slug}
                    className={`cursor-pointer ${
                      activeTab === tab.slug
                        ? "text-button-blue-bet dark:text-stroke-o3"
                        : "text-blur-gray"
                    }`}
                    onClick={() => handleChangeTab(tab.slug)}
                  >
                    {tab.title}
                  </div>
                ))
              : null}
          </div>

          <div
            className={
              "flex flex-row [&>*]:flex [&>*]:flex-row-reverse [&>*]:@md:flex-row [&>*]:justify-center [&>*]:items-center [&>*]:gap-1"
            }
          >
            <Checkbox
              color={"default"}
              size={"sm"}
              className={"max-lg:!flex-row-reverse max-lg:!text-right"}
              isSelected={isSameChecked}
              onValueChange={() => setIsSameChecked(!isSameChecked)}
            >
              Chủ khách tương đồng
            </Checkbox>
          </div>
        </div>
      </div>

      {activeTab === "goalNumber" && (
        <GoalNumber
          data={goalStats?.numberOfGoals}
          isSameChecked={isSameChecked}
        />
      )}
      {activeTab === "goalTime" && (
        <GoalTime data={goalStats?.timeScore} isSameChecked={isSameChecked} />
      )}
      {activeTab === "firstGoalTime" && (
        <FirstGoalTime
          data={goalStats?.timeFirstScore}
          isSameChecked={isSameChecked}
        />
      )}
    </div>
  );
};

const TAB_LIST = [
  {
    title: "Số bàn thắng",
    slug: "goalNumber",
  },
  {
    title: "Thời gian ghi bàn",
    slug: "goalTime",
  },
  {
    title: "Thời gian ghi bàn đầu tiên",
    slug: "firstGoalTime",
  },
];
const GoalTimeStats = ({ home, away, goalStats }) => {
  return (
    <div className={" px-0 lg:px-8 py-4"}>
      <Header home={home} away={away} title="Thời gian ghi bàn" />
      <Content tabs={TAB_LIST} goalStats={goalStats} />
    </div>
  );
};

export default GoalTimeStats;
